module.exports = __webpack_public_path__ + "media/collectCoin.e2aa065e.wav";